import { dataApi } from "services/data/DataService";
import { markMany, clear } from "store/cache/staleQueriesSlice";

/**
 * Пометить все существующие кэши endpoint как stale.
 */

export const markEndpointStale = ({ endpointName, exceptCacheKey = null }) => (dispatch, getState) => {

    const queries = getState()[dataApi.reducerPath]?.queries;
    if(!queries) {
        return;
    }

    
    const cacheKeys = Object.entries(queries)
        .filter(([cacheKey, query]) => query.endpointName === endpointName && 
            (exceptCacheKey === null || cacheKey !== exceptCacheKey)
        )   
        .map(([cacheKey]) => cacheKey);

    if (cacheKeys.length > 0) {
        dispatch(markMany(cacheKeys));
    }

};

/**
 * Снять stale у одного query.
 */
export const clearQueryStale = (cacheKey) => (dispatch) => {
    dispatch(clear(cacheKey));
};

/**
 * Проверить, является ли query stale.
 */
export const selectIsQueryStale = (state, cacheKey) => {
    return !!state.staleQueries[cacheKey];
};